/* eslint-disable react/prop-types */
import { useEffect } from 'react'
import {
  dataLoaderConfiguration,
  getErrorData,
  getHeaderStyle,
  getHeaderTitleId,
  getInitialValues,
  getIntegrationName,
  getLoadingData,
  getSubmitButtonText,
  getSuccessData,
  getTaskParameters,
} from './config'
import states from './states.json'

function DataLoader(props) {
  const {
    intl,
    currentUser,
    selectedEmployee,
    state,
    action,
    setActionHasAdditionalTasksToComplete,
    setInitialValues,
    setTaskParameters,
    setLoadingData,
    setSuccessData,
    setErrorData,
    setHeaderTitleId,
    setHeaderStyle,
    setSubmitButtonLangId,
    setIntegrationName,
    setState,
  } = props

  // Task parameters for actions that do not require callbacks for their task parameters. Only add data here that is accessible via the IntegrationManager
  const taskParameterData = {
    selectedEmployee,
  }

  useEffect(() => {
    // Ensure we are in our data loading state
    if (state !== states.DATA_LOADER) {
      return
    }

    // Set initial values (if using a formik wrapper)
    if (dataLoaderConfiguration.actionRequiresInitialValues[`${action}`]) {
      // Set the initial values of the form
      const initialValues = getInitialValues(action, currentUser, selectedEmployee)
      setInitialValues(initialValues)
    }

    // Set actionHasAdditionalTasksToComplete if the action fires off more than 1 task to the probe in a single flow
    if (dataLoaderConfiguration.actionSendsMultipleTasks[`${action}`]) {
      setActionHasAdditionalTasksToComplete(true)
    }

    // Set task parameters
    if (dataLoaderConfiguration.actionTaskParametersRequireCallback[`${action}`]) {
      // Task parameters require a callback to be used by the action component to set certain fields
      setTaskParameters(getTaskParameters(action))
    } else {
      try {
        const finalTaskParameters = getTaskParameters(action, taskParameterData)
        setTaskParameters(finalTaskParameters)
      } catch (error) {
        console.error(error)
      }
    }

    // Set action data objects
    setLoadingData(getLoadingData(action))
    setErrorData(getErrorData(action))
    setSuccessData(getSuccessData(action))
    setHeaderTitleId(getHeaderTitleId(action))
    setHeaderStyle(getHeaderStyle(action))
    setSubmitButtonLangId(getSubmitButtonText(action))
    setIntegrationName(getIntegrationName(action, intl))

    // Set the state to RENDER
    setState(states.RENDER)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export default DataLoader
